import { protectedAdminFetch, throwIfProtectedAdminResponseNotOk } from './protectedAdminApi';

export async function getUserAccountPdf(userId: string): Promise<Blob> {
  const response = await protectedAdminFetch(`/api/v1/admin/users/${encodeURIComponent(userId)}/personal-data.pdf`, { cache: 'no-store' });
  await throwIfProtectedAdminResponseNotOk(response, 'ACCOUNT_PDF_UNAVAILABLE');
  if (response.headers.get('X-Account-Id') !== userId
    || response.headers.get('Content-Type')?.split(';')[0].trim() !== 'application/pdf') {
    throw new Error('ACCOUNT_PDF_INVALID_RESPONSE');
  }
  const pdf = await response.blob();
  if (await pdf.slice(0, 5).text() !== '%PDF-') throw new Error('ACCOUNT_PDF_INVALID_FILE');
  return pdf;
}

export function saveUserAccountPdf(pdf: Blob): void {
  const url = URL.createObjectURL(pdf);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'doHockey-account-overview.pdf';
  try {
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // Allow the browser to start reading the download before releasing the URL.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
